import React, { Component } from 'react';
import './App.css';
import MainForm from './Components/mainForm.js';

class App extends Component 
{
	render() 
	{
    return (
			<div>
				<MainForm />
			</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js